import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../../../components/Navigation/Navigation';
import FrontendFooter from '../../../components/Layout/FrontendFooter';
import './EnquirySuccess.css';

const EnquirySuccess = () => {
  const navigate = useNavigate();

  const handleNewEnquiryClick = () => {
    navigate('/enquiry');
  };

  return (
    <div className="app-container">
      <Navigation />
      <main className="enquiry-success-container">
        <div className="success-message-box">
          <h1>Thank You for Your Enquiry!</h1>
          <p>We have received your enquiry and will get back to you shortly.</p>
          <button className="new-enquiry-button" onClick={handleNewEnquiryClick}>
            Add a New Enquiry
          </button>
        </div>
      </main>
      <FrontendFooter />
    </div>
  );
};

export default EnquirySuccess; 